// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --cards: 4;
    /* --cardHeight: max-content; */
    --cardTopPadding: 1.5em;
    --cardMargin: 8vw;
}

.container-what {
    width: 80%;
    margin: 0 auto;
    /* justify-content: center; */
}
@media (max-width:500px){
    .container-what {
        width: 100%;
        
        /* margin: 10px; */
        /* justify-content: center; */
    }
}

/* #cards {
    list-style: none;
    padding-left: 0;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(var(--cards), var(--cardHeight));
    gap: var(--cardMargin);
    padding-bottom: 30px;
} */
#cards {
    list-style: none;
    padding-left: 0;
    display: flex;
    height:'90vh';
    flex-wrap: wrap;
    /* gap: var(--cardMargin); */
    padding-bottom: 30px;
}


#card1 {
    --index: 1;
    flex-grow: 1;
}

#card2 {
    --index: 2;
    flex-grow: 1;
}

#card3 {
    --index: 3;
    flex-grow: 1;
}

#card4 {
    --index: 4;
    flex-grow: 1;
}

.card-what {
    position: sticky;
    top: 5%;
    /* max-height: 50vh; */
    /* bottom:'50%' */
    /* padding-top: calc(1 * var(--cardTopPadding)); */
    
}

#card1 .card-body {
    background: linear-gradient(to right, #aad6fc,#f4faff );
     background-color: #f9f9f9;
    /* background-color: #7EC4CF; */
    /* padding: 20px 50px; */
}

#card2 .card-body {
    /* background-color: #7EC4CF; */
    background: linear-gradient(to right, #aad6fc,#f4faff );
     background-color: #f9f9f9;
    /* background-color: #f9f9f9; */
}

#card3 .card-body {
    background: linear-gradient(to right, #aad6fc,#f4faff );
     background-color: #f9f9f9;
    /* background-color: #7EC4CF; */
}

#card4 .card-body {
    background: linear-gradient(to right, #aad6fc,#f4faff );
     background-color: #f9f9f9;
}

.card-body {
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom:20px;
    border-radius: 20px;
    /* box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.3); */
    /* height: var(--cardHeight); */
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s;
   
    
}

h2 {
    font-size: 2.5em;
}
.inside-contain {
    /* width: 95%; */
    /* height: max-content; */
    --comp-display: unset;
    align-self: center;
    justify-self: start;
    margin-top: 0px;
    margin-left: 0%;
    margin-bottom: 0px;
    grid-area: 1/1/2/2;
    position: relative;
    --is-sticky: 0;
    --top: 0px;
    --sticky-top: 0px;
    --sticky-offset: 0px;
    /* top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset))); */
    top:'0px';
    box-sizing: border-box;
    display: var(--l_display, var(--container-display));
    flex-direction: column;
    --container-display: flex;
}
.inside-contain-first {
    height: auto;
    width: 96%;
    line-height: 1.6em;
    top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset)));
    display: var(--l_display, var(--display));
    margin-left: 0%;
    margin-right: 0%;
    margin-top: 0px;
    margin-bottom: 2.5vw;
    align-self: flex-start;
    order: 2;
    position: relative;
    text-align: start;
    overflow-wrap: break-word;
    pointer-events: none;
}

.inside-contain-second {
    height: auto;
    width: 100%;
    top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset)));
    display: var(--l_display, var(--display));
    margin-left: 0%;
    margin-right: 0%;
    margin-top: 0px;
    margin-bottom: 0;
    align-self: flex-start;
    order: 1;
    position: relative;
    text-align: start;
    overflow-wrap: break-word;
    pointer-events: none;
}
.inside-contain-third {
    height: 50px;
    /* width: 160px; */
    min-height: 0px;
    --sticky-top: 16vw;
    top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset)));
    display: var(--l_display, var(--display));
    margin-left: 0%;
    margin-right: 0%;
    margin-top: 0px;
    /* margin-bottom: 30px; */
    align-self: flex-start;
    order: 3;
    position: relative;
    text-align: start;
    overflow-wrap: break-word;
    pointer-events: none;

}
.second-what-container{
    width:100%;
    padding-top: 3.5%;
    padding-bottom: 3.5%;
    padding-left: 3.5%;
    padding-right: 1%;
    margin-left:20px;
    margin-right: 5px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 0.7fr;
    position: relative;
    box-sizing: border-box;
    --l_display:unset;
    --container-display:grid;
    display: var(--l_display,var(--container-display));
}
@media (max-width:1000px) {
    .second-what-container{
        grid-template-columns: 1fr;
        /* grid-template-rows: auto; */
        
        padding-left: 0%;
        padding-right: 0%;
        gap: 10px;
    }
}

@media (max-width:500px){
    .card-what {
        position: sticky;
        top: -50%;
        /* max-height: 50vh; */
        /* bottom:'50%' */
        /* padding-top: calc(1 * var(--cardTopPadding)); */
        
    }
}`, "",{"version":3,"sources":["webpack://./src/Home/Whatwedo.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,+BAA+B;IAC/B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,6BAA6B;AACjC;AACA;IACI;QACI,WAAW;;QAEX,kBAAkB;QAClB,6BAA6B;IACjC;AACJ;;AAEA;;;;;;;;GAQG;AACH;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,aAAa;IACb,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;AACxB;;;AAGA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,sBAAsB;IACtB,iBAAiB;IACjB,kDAAkD;;AAEtD;;AAEA;IACI,uDAAuD;KACtD,yBAAyB;IAC1B,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,uDAAuD;KACtD,yBAAyB;IAC1B,+BAA+B;AACnC;;AAEA;IACI,uDAAuD;KACtD,yBAAyB;IAC1B,+BAA+B;AACnC;;AAEA;IACI,uDAAuD;KACtD,yBAAyB;AAC9B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,+CAA+C;IAC/C,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;;;AAGxB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,6GAA6G;IAC7G,SAAS;IACT,sBAAsB;IACtB,mDAAmD;IACnD,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,uGAAuG;IACvG,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,uGAAuG;IACvG,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,uGAAuG;IACvG,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;;AAExB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,kDAAkD;AACtD;AACA;IACI;QACI,0BAA0B;QAC1B,8BAA8B;;QAE9B,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;QACT,sBAAsB;QACtB,iBAAiB;QACjB,kDAAkD;;IAEtD;AACJ","sourcesContent":[":root {\n    --cards: 4;\n    /* --cardHeight: max-content; */\n    --cardTopPadding: 1.5em;\n    --cardMargin: 8vw;\n}\n\n.container-what {\n    width: 80%;\n    margin: 0 auto;\n    /* justify-content: center; */\n}\n@media (max-width:500px){\n    .container-what {\n        width: 100%;\n        \n        /* margin: 10px; */\n        /* justify-content: center; */\n    }\n}\n\n/* #cards {\n    list-style: none;\n    padding-left: 0;\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(var(--cards), var(--cardHeight));\n    gap: var(--cardMargin);\n    padding-bottom: 30px;\n} */\n#cards {\n    list-style: none;\n    padding-left: 0;\n    display: flex;\n    height:'90vh';\n    flex-wrap: wrap;\n    /* gap: var(--cardMargin); */\n    padding-bottom: 30px;\n}\n\n\n#card1 {\n    --index: 1;\n    flex-grow: 1;\n}\n\n#card2 {\n    --index: 2;\n    flex-grow: 1;\n}\n\n#card3 {\n    --index: 3;\n    flex-grow: 1;\n}\n\n#card4 {\n    --index: 4;\n    flex-grow: 1;\n}\n\n.card-what {\n    position: sticky;\n    top: 5%;\n    /* max-height: 50vh; */\n    /* bottom:'50%' */\n    /* padding-top: calc(1 * var(--cardTopPadding)); */\n    \n}\n\n#card1 .card-body {\n    background: linear-gradient(to right, #aad6fc,#f4faff );\n     background-color: #f9f9f9;\n    /* background-color: #7EC4CF; */\n    /* padding: 20px 50px; */\n}\n\n#card2 .card-body {\n    /* background-color: #7EC4CF; */\n    background: linear-gradient(to right, #aad6fc,#f4faff );\n     background-color: #f9f9f9;\n    /* background-color: #f9f9f9; */\n}\n\n#card3 .card-body {\n    background: linear-gradient(to right, #aad6fc,#f4faff );\n     background-color: #f9f9f9;\n    /* background-color: #7EC4CF; */\n}\n\n#card4 .card-body {\n    background: linear-gradient(to right, #aad6fc,#f4faff );\n     background-color: #f9f9f9;\n}\n\n.card-body {\n    box-sizing: border-box;\n    padding-top: 20px;\n    padding-bottom:20px;\n    border-radius: 20px;\n    /* box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.3); */\n    /* height: var(--cardHeight); */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.5s;\n   \n    \n}\n\nh2 {\n    font-size: 2.5em;\n}\n.inside-contain {\n    /* width: 95%; */\n    /* height: max-content; */\n    --comp-display: unset;\n    align-self: center;\n    justify-self: start;\n    margin-top: 0px;\n    margin-left: 0%;\n    margin-bottom: 0px;\n    grid-area: 1/1/2/2;\n    position: relative;\n    --is-sticky: 0;\n    --top: 0px;\n    --sticky-top: 0px;\n    --sticky-offset: 0px;\n    /* top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset))); */\n    top:'0px';\n    box-sizing: border-box;\n    display: var(--l_display, var(--container-display));\n    flex-direction: column;\n    --container-display: flex;\n}\n.inside-contain-first {\n    height: auto;\n    width: 96%;\n    line-height: 1.6em;\n    top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset)));\n    display: var(--l_display, var(--display));\n    margin-left: 0%;\n    margin-right: 0%;\n    margin-top: 0px;\n    margin-bottom: 2.5vw;\n    align-self: flex-start;\n    order: 2;\n    position: relative;\n    text-align: start;\n    overflow-wrap: break-word;\n    pointer-events: none;\n}\n\n.inside-contain-second {\n    height: auto;\n    width: 100%;\n    top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset)));\n    display: var(--l_display, var(--display));\n    margin-left: 0%;\n    margin-right: 0%;\n    margin-top: 0px;\n    margin-bottom: 0;\n    align-self: flex-start;\n    order: 1;\n    position: relative;\n    text-align: start;\n    overflow-wrap: break-word;\n    pointer-events: none;\n}\n.inside-contain-third {\n    height: 50px;\n    /* width: 160px; */\n    min-height: 0px;\n    --sticky-top: 16vw;\n    top: calc((1- var(--is-sticky))*var(--top)+var(--is-sticky)*(var(--sticky-top) + var(--sticky-offset)));\n    display: var(--l_display, var(--display));\n    margin-left: 0%;\n    margin-right: 0%;\n    margin-top: 0px;\n    /* margin-bottom: 30px; */\n    align-self: flex-start;\n    order: 3;\n    position: relative;\n    text-align: start;\n    overflow-wrap: break-word;\n    pointer-events: none;\n\n}\n.second-what-container{\n    width:100%;\n    padding-top: 3.5%;\n    padding-bottom: 3.5%;\n    padding-left: 3.5%;\n    padding-right: 1%;\n    margin-left:20px;\n    margin-right: 5px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 0.7fr;\n    position: relative;\n    box-sizing: border-box;\n    --l_display:unset;\n    --container-display:grid;\n    display: var(--l_display,var(--container-display));\n}\n@media (max-width:1000px) {\n    .second-what-container{\n        grid-template-columns: 1fr;\n        /* grid-template-rows: auto; */\n        \n        padding-left: 0%;\n        padding-right: 0%;\n        gap: 10px;\n    }\n}\n\n@media (max-width:500px){\n    .card-what {\n        position: sticky;\n        top: -50%;\n        /* max-height: 50vh; */\n        /* bottom:'50%' */\n        /* padding-top: calc(1 * var(--cardTopPadding)); */\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
